import React, { SyntheticEvent, useState } from "react";
import axios from "axios";
import { Navigate, useParams } from "react-router-dom";
import { FaLock, FaEye, FaEyeSlash, FaExclamationCircle, FaKey } from "react-icons/fa";

export const Reset = () => {
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { token } = useParams();

    const submit = async (e: SyntheticEvent) => {
        e.preventDefault();
        setError('');

        if (password !== passwordConfirm) {
            setError('Lambarka sirta isma laha');
            return;
        }

        if (password.length < 8) {
            setError('Lambarka sirta waa inuu ka koobnaadaa ugu yaraan 8 xarfood');
            return;
        }

        setLoading(true);

        try {
            await axios.post('/users/reset', {
                token,
                password,
                password_confirm: passwordConfirm
            });

            setRedirect(true);
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Waala waayay in la hagaajiyo lambarka sirta. Fadlan isku day mar kale.');
        } finally {
            setLoading(false);
        }
    }

    if (redirect) {
        return <Navigate to="/login" />;
    }

    return (
        <div className="auth-container">
            <div className="auth-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
                <div className="gradient-orb orb-3"></div>
            </div>

            <div className="auth-content">
                <div className="reset-card">
                    <div className="reset-header">
                        <div className="icon-container">
                            <FaKey size={36} />
                        </div>
                        <h2 className="reset-title">Dib-u-hagaaji Lambarka Sirta</h2>
                        <p className="reset-subtitle">
                            Geli lambarkaaga sirta ah ee cusub si aad u hagaajisato ciwaankaaga
                        </p>
                    </div>

                    {error && (
                        <div className="auth-alert error">
                            <span className="alert-icon"><FaExclamationCircle /></span>
                            <span>{error}</span>
                        </div>
                    )}

                    <form onSubmit={submit} className="reset-form">
                        <div className="form-group">
                            <label htmlFor="password" className="form-label">Lambarka Sirta Cusub</label>
                            <div className="input-wrapper">
                                <FaLock className="input-icon" />
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    className="form-input"
                                    placeholder="Geli lambarka sirta cusub"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    required
                                    disabled={loading}
                                />
                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() => setShowPassword(!showPassword)}
                                    tabIndex={-1}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>
                            <div className="password-strength">
                                <span className={password.length >= 8 ? 'valid' : 'invalid'}>
                                    {password.length >= 8 ? '✓' : '○'} Ugu yaraan 8 xarfood
                                </span>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="passwordConfirm" className="form-label">Xaqiiji Lambarka Sirta</label>
                            <div className="input-wrapper">
                                <FaLock className="input-icon" />
                                <input
                                    type={showPasswordConfirm ? "text" : "password"}
                                    id="passwordConfirm"
                                    className="form-input"
                                    placeholder="Xaqiiji lambarka sirta cusub"
                                    value={passwordConfirm}
                                    onChange={e => setPasswordConfirm(e.target.value)}
                                    required
                                    disabled={loading}
                                />
                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                                    tabIndex={-1}
                                >
                                    {showPasswordConfirm ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>
                            {passwordConfirm && (
                                <div className="password-strength">
                                    <span className={password === passwordConfirm ? 'valid' : 'invalid'}>
                                        {password === passwordConfirm ? '✓' : '○'} Lambarka sirta waa is leeyihiin
                                    </span>
                                </div>
                            )}
                        </div>

                        <button
                            type="submit"
                            className="auth-button"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner"></span>
                                    <span>Hagaajinaya...</span>
                                </>
                            ) : (
                                'Dib-u-hagaaji Lambarka Sirta'
                            )}
                        </button>
                    </form>
                </div>
            </div>

            <style>{`
                .auth-container {
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                    position: relative;
                    overflow: hidden;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                }

                .auth-background {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    overflow: hidden;
                    z-index: 0;
                }

                .gradient-orb {
                    position: absolute;
                    border-radius: 50%;
                    filter: blur(80px);
                    opacity: 0.6;
                    animation: float 20s ease-in-out infinite;
                }

                .orb-1 {
                    width: 500px;
                    height: 500px;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    top: -250px;
                    left: -250px;
                }

                .orb-2 {
                    width: 400px;
                    height: 400px;
                    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
                    bottom: -200px;
                    right: -200px;
                    animation-delay: 5s;
                }

                .orb-3 {
                    width: 350px;
                    height: 350px;
                    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    animation-delay: 10s;
                }

                @keyframes float {
                    0%, 100% { transform: translate(0, 0) scale(1); }
                    25% { transform: translate(30px, -30px) scale(1.1); }
                    50% { transform: translate(-20px, 20px) scale(0.9); }
                    75% { transform: translate(20px, 30px) scale(1.05); }
                }

                .auth-content {
                    position: relative;
                    z-index: 1;
                    width: 100%;
                    max-width: 480px;
                }

                .reset-card {
                    background: rgba(255, 255, 255, 0.95);
                    backdrop-filter: blur(20px);
                    border-radius: 24px;
                    padding: 48px;
                    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
                    animation: slideUp 0.6s ease-out;
                }

                @keyframes slideUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .reset-header {
                    text-align: center;
                    margin-bottom: 32px;
                }

                .icon-container {
                    width: 80px;
                    height: 80px;
                    margin: 0 auto 24px;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
                }

                .reset-title {
                    font-size: 28px;
                    font-weight: 700;
                    color: #1a202c;
                    margin: 0 0 12px 0;
                    letter-spacing: -0.5px;
                }

                .reset-subtitle {
                    font-size: 15px;
                    color: #718096;
                    margin: 0;
                    line-height: 1.6;
                }

                .auth-alert {
                    padding: 14px 16px;
                    border-radius: 12px;
                    margin-bottom: 24px;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    font-size: 14px;
                    animation: slideDown 0.4s ease-out;
                }

                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .auth-alert.error {
                    background: #fee;
                    color: #c53030;
                    border: 1px solid #fc8181;
                }

                .alert-icon {
                    font-size: 18px;
                    display: flex;
                }

                .reset-form {
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                }

                .form-group {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                }

                .form-label {
                    font-size: 14px;
                    font-weight: 600;
                    color: #2d3748;
                }

                .input-wrapper {
                    position: relative;
                    display: flex;
                    align-items: center;
                }

                .input-icon {
                    position: absolute;
                    left: 16px;
                    color: #a0aec0;
                    font-size: 16px;
                    pointer-events: none;
                }

                .form-input {
                    width: 100%;
                    padding: 14px 48px 14px 48px;
                    border: 2px solid #e2e8f0;
                    border-radius: 12px;
                    font-size: 15px;
                    transition: all 0.3s ease;
                    background: white;
                }

                .form-input:focus {
                    outline: none;
                    border-color: #667eea;
                    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
                }

                .form-input:disabled {
                    background: #f7fafc;
                    cursor: not-allowed;
                }

                .password-toggle {
                    position: absolute;
                    right: 16px;
                    background: none;
                    border: none;
                    color: #a0aec0;
                    cursor: pointer;
                    padding: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: color 0.2s;
                }

                .password-toggle:hover {
                    color: #667eea;
                }

                .password-strength {
                    font-size: 13px;
                    margin-top: 4px;
                }

                .password-strength span {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                }

                .password-strength .valid {
                    color: #38a169;
                }

                .password-strength .invalid {
                    color: #a0aec0;
                }

                .auth-button {
                    width: 100%;
                    padding: 14px 24px;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    color: white;
                    border: none;
                    border-radius: 12px;
                    font-size: 16px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
                    margin-top: 8px;
                }

                .auth-button:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
                }

                .auth-button:active:not(:disabled) {
                    transform: translateY(0);
                }

                .auth-button:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }

                .spinner {
                    width: 16px;
                    height: 16px;
                    border: 2px solid rgba(255, 255, 255, 0.3);
                    border-top-color: white;
                    border-radius: 50%;
                    animation: spin 0.6s linear infinite;
                }

                @keyframes spin {
                    to { transform: rotate(360deg); }
                }

                @media (max-width: 640px) {
                    .reset-card {
                        padding: 32px 24px;
                    }

                    .reset-title {
                        font-size: 24px;
                    }

                    .icon-container {
                        width: 64px;
                        height: 64px;
                    }
                }
            `}</style>
        </div>
    );
};